var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "j-form-container",
          [
            _c(
              "a-form-model",
              {
                ref: "form",
                attrs: {
                  slot: "detail",
                  model: _vm.model,
                  rules: _vm.validatorRules
                },
                slot: "detail"
              },
              [
                _c(
                  "a-row",
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label: this.language["ad.name"],
                              labelCol: _vm.labelCol,
                              wrapperCol: _vm.wrapperCol,
                              prop: "name"
                            }
                          },
                          [
                            _c("a-input", {
                              attrs: {
                                placeholder: this.language["ad.must.name"]
                              },
                              model: {
                                value: _vm.model.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "name", $$v)
                                },
                                expression: "model.name"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label: "已选广告",
                              labelCol: _vm.labelCol,
                              wrapperCol: _vm.wrapperCol,
                              prop: "name"
                            }
                          },
                          [
                            _c("ad-select", {
                              attrs: { multiple: true },
                              model: {
                                value: _vm.model.adOptions,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "adOptions", $$v)
                                },
                                expression: "model.adOptions"
                              }
                            }),
                            _c("a-button", { on: { click: _vm.getValue } }, [
                              _vm._v("获取select值")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }